import router from '../../../shared/router';
import Login from './Login';

const {routes} = router.options;
const mainRoute = routes.find(r => r.name === 'auth');

mainRoute.children.push(
  {
    path: 'login',
    component: Login,
    meta: {
      guest: true,
    },
  },
);

router.addRoutes([mainRoute]);
